import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { PagedResponse } from '../../../../shared/contract/paged-response.contract';
import { getHttpParameters } from '../../../../shared/utils/get-http-parameters';
import { AcknowledgeAutomatedTransferNotificationCommand } from '../../contract/acknowledge-automated-transfer-notificaton-command.contract';
import { AutomatedTransferNotification } from '../../contract/automated-transfer-notification.contract';
import { AutomatedTransferNotificationsCount } from '../../contract/automated-transfer-notifications-count.contract';
import { AutomatedTransfersAlarmNotificationsParams } from '../contract/automated-transfers-alarm-notifications-params.contract';
import { SseClientService } from '../../../../shared/services/sse-client.service';

@Injectable({ providedIn: 'root' })
export class AutomatedTransfersNotificationsApiService {
  private http = inject(HttpClient);
  private readonly sseClient = inject(SseClientService);

  private readonly url = environment.APP_DISPOSITION_SERVICE_BASE_URL;
  private readonly automatedTransfersUrl = `${this.url}/api/v1/automated-transfers`;

  public getCurrentActive(
    request: AutomatedTransfersAlarmNotificationsParams,
  ): Observable<PagedResponse<AutomatedTransferNotification>> {
    const httpParams = getHttpParameters(request);
    return this.http.get<PagedResponse<AutomatedTransferNotification>>(
      `${this.automatedTransfersUrl}/notifications/alarms/current-active`,
      { params: httpParams },
    );
  }

  public getCurrentActiveCount(): Observable<AutomatedTransferNotificationsCount> {
    return this.sseClient.stream<AutomatedTransferNotificationsCount>(
      `${this.automatedTransfersUrl}/notifications/alarms/current-active/count`,
    );
  }

  public acknowledgeAutomatedTransferNotification(
    command: AcknowledgeAutomatedTransferNotificationCommand,
  ): Observable<string> {
    return this.http.post(
      `${this.automatedTransfersUrl}/notifications/alarms/${command.id}/acknowledge`,
      JSON.stringify(command),
      {
        responseType: 'text',
      },
    );
  }

  public acknowledgeAllAutomatedTransferNotifications(): Observable<void> {
    return this.http.post<void>(`${this.automatedTransfersUrl}/notifications/alarms/acknowledge/all`, null);
  }
}
